import React from 'react';
import { Grid } from 'semantic-ui-react';

import GridColumnInputWrapper from '../../../../common/GridColumnInputWrapper';
import { AccordionWrapper, InputWrapper } from 'react-lib/dist/components-es';
import { setRowSize } from 'utils';

type Props = {
  values: any;
  disabled: boolean;
  setFieldValue: (arg1: string, arg2: string) => void;
  errors: any;
};

const IOtherPrecautions = ({ values, disabled, errors, setFieldValue }: Props) => {
  const getContainerContent = () => {
    const inputText = values.chemicalRiskAttributes.precautionsAndEmergencyProcedures || '';
    const rows = setRowSize(inputText, 2, 90);

    return (
      <Grid stackable columns={1} verticalAlign="bottom">
        <GridColumnInputWrapper
          rows={rows}
          value={inputText}
          name="chemicalRiskAttributes.precautionsAndEmergencyProcedures"
          type="textarea"
          disabled={disabled}
          values={values}
          errors={errors}
          setFieldValue={setFieldValue}
          render={(props: any) => <InputWrapper {...props} />}
        />
      </Grid>
    );
  };
  return (
    <AccordionWrapper
      accordionTitle="inventory.details.page.other.precautions.container.title"
      className="containerReducedWhiteSpace"
      render={getContainerContent}
    />
  );
};

export default IOtherPrecautions;
